import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import AnimateHeight from 'react-animate-height';
import arrowIcon from '../../../../images/icons/arrow-up.svg';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';
import starsIcon from '../../../../images/icons/stars.svg';
import ProductPreview from '../../../products/components/product_preview/ProductPreview';
import { productsActions } from '../../../products/actions';
import { upSellsSelector } from '../../selectors/up_sells';
import './UpSells.sass';

function UpSells(props) {
  const [expanded, setExpanded] = useState(true);

  const toggle = () => setExpanded(!expanded);

  const { upSells, addToBag } = props;

  if (!upSells || upSells.length === 0) { return null; }

  return (
    <div className={classNames('up-sells', { active: expanded })}>
      <ClickableDiv
        className="toggle"
        onClick={toggle}
      >
        <div className="title">
          <img src={starsIcon} alt="" />
          Limited time offer just for you
        </div>
        <div className="arrow">
          <img src={arrowIcon} alt="" width="14px" />
        </div>
      </ClickableDiv>
      <AnimateHeight
        duration={400}
        height={expanded ? 'auto' : 0}
      >
        <div className="up-sells-container">
          { upSells.map((product) => (
            <ProductPreview
              key={product.id}
              product={product}
              addToBag={addToBag}
              className="product-preview"
              buttonColor="yellow"
              showDiscountPercentage
            />
          ))}
        </div>
      </AnimateHeight>
    </div>
  );
}

UpSells.propTypes = {
  upSells: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  addToBag: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  upSells: upSellsSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  addToBag: (id) => dispatch(productsActions.addToBagRequest(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpSells);
